import type { UpdateOrganizationInput } from "@/admin/entities/organizations";

interface EditData {
  organization: {
    assistant?: {
      enabled: boolean;
      model?: string | null;
      monthlyBudgetUsd?: number | null;
    } | null;
  } & Record<string, unknown>;
}

/** Шаг «Помощник партнёра» сохраняет только свой блок (корневые шаги со своими getEditData, AGENTS.md). */
export function getAssistantEditData(data: unknown): UpdateOrganizationInput {
  const { organization } = data as EditData;
  const assistant = organization.assistant;
  return {
    assistant: {
      enabled: assistant?.enabled ?? false,
      model: assistant?.model ?? "claude-sonnet-5",
      monthlyBudgetUsd: assistant?.monthlyBudgetUsd ?? null,
    },
  };
}
